/* Founders' Mural artwork: the original Pawn of God pawn on a 40x50 grid (2,000 blocks).
   PogMuralArt.ART[i] = colour of block i (row-major); PogMuralArt.RANK[i] = the Founder number (0-based) that fills it.
   Build order: the crown first, then every other block at random (fixed seed, so it never changes). */
window.PogMuralArt = (function () {
  'use strict';
  var W = 40, H = 50;
  var V = ['#12051f','#2a0a45','#55107a','#9c1aa6','#e0349e','#ff7ab8','#7fe9ff','#e8fdff'];
  var I = ['#0c0204','#2e060a','#600c10','#a01a12','#e04414','#ff8a2a','#ff6ab4','#ffe6f2'];
  var G = ['#a8680c','#e8a62a','#ffe08a'], HOT = '#fff8dc', O = '#07040c';
  var SKY = ['#03101a','#06223a','#0c3a5c','#14587a'], FL = ['#06223a','#0c3a5c'];
  var CX = 19, HY = 30.5, R = 11.5, KY = 10;
  function hs(x, y) { var s = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453; return s - Math.floor(s); }
  function head(x, y) { return (x - CX) * (x - CX) + (y + .5 - HY) * (y + .5 - HY) <= R * R; }
  function base(x, y) { return (y === 43 && Math.abs(x - CX) <= 6) || (y >= 44 && y <= 46 && Math.abs(x - CX) <= 8); }
  function lensV(x, y) { var a = Math.pow((x - 13) / 3.4, 2) + Math.pow((y + .5 - 29.5) / 6.7, 2), b = Math.pow((x - 25) / 3.4, 2) + Math.pow((y + .5 - 29.5) / 6.7, 2); return Math.min(a, b); }
  function frame(x, y) { var v = lensV(x, y); return (v <= 1 && v >= .5) || (y === 23 && x >= 17 && x <= 21) || (x === CX && y >= 21 && y <= 31); }
  function spark(x, y) { var P = [[13, 26], [25, 26]]; for (var i = 0; i < 2; i++) { var a = P[i][0], b = P[i][1]; if (x === a && y === b) return 2; if (Math.abs(x - a) + Math.abs(y - b) === 1 || (x === a && Math.abs(y - b) === 2)) return 1; } return 0; }
  function yb(d) { return 13.4 + 2.8 * Math.sqrt(Math.max(0, 1 - Math.pow(d / 9.8, 2))); }
  function gemV(d, y) { return Math.abs(d) / 2.3 + Math.abs(y - 11.5) / 2.9; }
  function crownPart(x, y) {
    var d = x - CX;
    if (gemV(d, y) <= 1) return 'gem';
    if (y >= 12 && Math.abs(d) <= 9.6 && y + .5 <= yb(d)) return 'body';
    if (y >= 2 && y <= 12 && Math.abs(d) <= 3.6 * Math.pow((y - 1.5) / 10.5, 1.6) + .35) return 'c';
    for (var s = -1; s <= 1; s += 2) { var c = s * (8.6 - (y - 6) * .45); if (y >= 6 && y <= 12 && Math.abs(d - c) <= 2.3 * Math.pow((y - 5.5) / 7.5, 1.4) + .35) return s < 0 ? 'sl' : 'sr'; }
    return null;
  }
  function crownFill(x, y, p) {
    var d = x - CX;
    if (p === 'gem') { var v = gemV(d, y); if (v > .68) return y < 11.5 && d <= 0 ? G[2] : G[0]; if (d === -1 && y === 10) return '#ffffff'; if (d < 0) return y < 11.5 ? I[7] : I[6]; return y < 11.5 ? V[5] : V[4]; }
    if (p === 'body') { if (y + 1.5 > yb(d)) return (x + y) % 2 ? G[0] : '#7a4a08'; if (y === 14 && (Math.abs(d) === 5 || Math.abs(d) === 8)) return HOT; if (y === 12) return d < 3 ? HOT : G[2]; return d < -3 ? G[2] : d < 4 ? G[1] : G[0]; }
    if ((p === 'sl' || p === 'sr') && y === 11 && Math.abs(Math.abs(d) - (8.6 - 2.25)) <= .5) return V[6];
    if (y <= 5) return HOT;
    if (p === 'c') return d < 0 ? G[2] : d === 0 ? (y < 8 ? HOT : G[2]) : G[1];
    if (p === 'sl') return d < -7 ? G[2] : G[1];
    return d > 7 ? G[0] : G[1];
  }
  var SP = [[5, 5, 2], [33, 4, 2], [2, 14, 1], [37, 13, 1], [9, 1, 1], [29, 1, 1], [1, 23, 1], [38, 22, 1], [34, 19, 1], [4, 19, 1]];
  function star(x, y) {
    for (var i = 0; i < SP.length; i++) {
      var a = SP[i][0], b = SP[i][1], L = SP[i][2];
      if (x === a && y === b) return HOT;
      if ((x === a && Math.abs(y - b) <= L) || (y === b && Math.abs(x - a) <= L)) return G[2];
      if (L === 2 && Math.abs(x - a) === 1 && Math.abs(y - b) === 1) return G[0];
    }
    return null;
  }
  var GL = [SKY[1], SKY[2], G[0], G[1]];
  function glow(x, y) {
    var d = Math.hypot(x - CX, (y - KY) * 1.15), a = Math.atan2(y - KY, x - CX), ray = Math.floor((a + Math.PI) * 2.55) % 2 === 0, ch = (x + y) % 2;
    if (d < 13.5) return ch ? GL[3] : GL[2];
    if (d < 16.5) return ch ? GL[2] : GL[1];
    if (ray && d < 34) { if (hs(x, y) > .975) return G[1]; if (d < 22) return ch ? GL[1] : GL[0]; if (d < 28) return ch ? GL[0] : null; return (x % 2 && y % 2) ? GL[0] : null; }
    return null;
  }
  function mask(x, y) { return head(x, y) || base(x, y) || !!crownPart(x, y); }
  function m(x, y) { return x >= 0 && y >= 0 && x < W && y < H && mask(x, y); }
  function pawn(x, y) {
    var p = crownPart(x, y); if (p) return crownFill(x, y, p);
    if (frame(x, y) || spark(x, y)) return O;
    var h = hs(x, y); if (h > .93) return '#d3dbe4';
    if (base(x, y)) { if (y === 43) return '#fbf3df'; return x - CX > 4 ? '#c4d4e0' : '#f2efe9'; }
    var l = (HY - y) / R; if (l > .72) return HOT; if (l > .45) return (x + y) % 2 ? '#fbf3df' : '#f2efe9';
    if (lensV(x, y) < .5 && y <= 24 && (x === 12 || x === 24)) return '#ffe9b0';
    var rim = (x - CX) * (x - CX) + (y - HY) * (y - HY) > R * R * .68 && y > HY - 3;
    if (rim && x > CX) return (x + y) % 2 || h > .5 ? '#c4d4e0' : '#dbe4ec';
    if (rim && y > HY + 6) return '#dbe4ec';
    return '#f2efe9';
  }
  function bg(x, y) {
    var s = star(x, y); if (s) return s;
    var h = hs(x, y);
    if (y >= 46) { if (y <= 47 && Math.abs(x - CX) <= 10) return y === 46 ? '#1a2a2a' : SKY[0]; var r = y - 46, w = 2 + r * .6; return (Math.floor((x - CX) / w + 100) + r) % 2 ? FL[0] : FL[1]; }
    var gl = glow(x, y); if (gl) return gl;
    var b = y < 14 ? 0 : y < 30 ? 1 : 2; if ((y === 13 || y === 29) && (x + y) % 2) b++; if (h > .995 && y < 30) return '#e8fdff'; if (h > .93) b++;
    return SKY[Math.min(b, 3)];
  }
  var ART = [], x, y, i;
  for (y = 0; y < H; y++) for (x = 0; x < W; x++) ART.push(m(x, y) ? ((!m(x - 1, y) || !m(x + 1, y) || !m(x, y - 1) || !m(x, y + 1)) ? O : pawn(x, y)) : bg(x, y));
  function rnd(s) { return function () { s |= 0; s = s + 0x6D2B79F5 | 0; var t = Math.imul(s ^ s >>> 15, 1 | s); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  var r = rnd(2026), keys = [];
  for (i = 0; i < W * H; i++) keys.push([i, (crownPart(i % W, Math.floor(i / W)) ? 0 : 1) + r()]);
  keys.sort(function (a, b) { return a[1] - b[1]; });
  var RANK = new Int32Array(W * H);
  keys.forEach(function (k, n) { RANK[k[0]] = n; });
  return { W: W, H: H, ART: ART, RANK: RANK };
})();
